export const formDefaultValues = {
  insurance: '',
  policyNumber: '',
  comment: '',
}
